<template>
  <div ref="formContainer">
    <div class="card card-body p-0" style="border-radius: 10px">
      <NotificationsFilter @selectNotificationTab="selTab" @setPage="setPage" @skeletonLoader="setSkeletonLoader"></NotificationsFilter>
      <notifications-table :notifications="notifications" :totalPages="totalPages" :totalRows="totalRows" :page="page" @setPage="setPage" :selTab="sel_tab" :setSkeletonLoader="displayLoader">
      </notifications-table>
    </div>
  </div>
</template>

<script>
  import helpers from "@/helpers.js";
  import NotificationsFilter from "./notifications_filter.vue";
  import NotificationsTable from "./notifications_table";
  import VueSkeletonLoader from 'skeleton-loader-vue';
  export default {
    components: {
      NotificationsTable,VueSkeletonLoader,NotificationsFilter
    },

    data: function () {
      return {
        page: 0,
        fullPage: "",
        displayLoader: true,
        status:'all',
        sel_tab: 'all',
      };
    },

    computed: {
      notifications: function () {
        return this.$store.getters["users/notifications"];
      },
      
      totalPages: function () {
        return this.$store.getters["users/totalPages"];
      },
      totalRows : function () {
        return this.$store.getters["users/totalRows"];
      },
    },

    created: function () {
      this.sel_tab = "all";
      this.search = '';
      this.page = helpers.getPageQuery();
    },

    watch: {
      page: function (val) {
        this.setSkeletonLoader(true);
        this.$store.dispatch("users/getAllnotifications", [val,this.sel_tab,this.search]).then(() => {
          this.setSkeletonLoader(false);
        });
      },
      notificationsStatus: function (val) {
        this.sel_tab = val ;
        return val;
      },
      notificationsSearch: function (val) {
        this.search = val ;
        return val;
      },
    },

    methods: {
      setPage(page) {
        this.page = page;
        if(this.$route.query.page != 1){
          this.$router.push("notifications?page=" + page);
        } 
      },
      setSkeletonLoader(val){
        this.displayLoader = val;
      },
      selTab(event) {
        this.sel_tab = event;
      },
    },
  };
</script>
<style>
  .custom {
    position: absolute;
    z-index: 999;
    top: 246px;
    left: 40%;
    opacity: 0.5;
  }
</style>